import { Typography } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  /* padding: 15px; */
  background: #f5f5f5;
  display: flex;
  height: calc(100vh - 64px);
  flex-direction: column;
  width: 100%;
`;

export const ContainerButton = styled.div`
  width: 100%;
  margin-bottom: 24px;
  button {
    border: solid 1px #000000;
    border-radius: 18px;
    height: 36px;
    padding: 0 15px;
    gap: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const CardContainer = styled.div<{ space?: string }>`
  display: flex;
  background: #ffffff;
  border-radius: 4px;
  width: 100%;
  flex-direction: column;
  padding: ${({ space }) => ` ${space}`};
`;

export const CardContainerButton = styled.div<{ space?: string }>`
  display: flex;
  background: #ffffff;
  border-radius: 4px;
  width: 100%;
  padding: ${({ space }) => ` ${space}`};
  cursor: pointer;
  align-items: center;
`;

export const NewMessageBadge = styled.div`
  height: 8px;
  width: 10px;
  border-radius: 50%;
  background: red;
  margin: 0 20px;
`;

export const Grid = styled.div`
  gap: 24px;
  width: 100%;
  display: flex;
`;

export const GridLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 379px;
`;

export const GridRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 639px;
`;

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 639px;
`;

export const ContainerArrow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 639px;
  align-self: center;
`;

export const Time = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ContainerDatasers = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerChat = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContainerMessages = styled.div`
  display: flex;
  flex-direction: column;
  background: #fafafa;
  padding: 16px;
  width: 100%;

  height: calc(100vh - 358.5px);

  p {
    margin-top: 5px;
  }
  overflow: auto;
`;

export const MessagesInput = styled.div`
  display: flex;
  flex-direction: column;
  background: #fafafa;
  padding: 16px;
  width: 100%;
`;

export const Message = styled(Typography)<{ alignSelf: string }>`
  display: flex;
  padding: 7px 10px;
  border-radius: ${({ alignSelf }) =>
    alignSelf === "flex-start" ? `16px 16px 16px 0px` : `16px 16px 0 16px`};
  background: ${({ alignSelf }) =>
    alignSelf === "flex-start" ? `rgba(0, 0, 0, 0.08)` : `#D33100`};
  color: ${({ alignSelf }) =>
    alignSelf === "flex-start" ? `#000000` : `#FFFFFF`};
  width: fit-content;
  align-self: ${({ alignSelf }) => alignSelf};
  flex-direction: column;
`;

export const ContainerIcon = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  margin: 5px 0;
`;

export const ContainerMessage = styled.div`
  display: flex;
  align-items: center;
  background: #fafafa;
`;

export const ContentMessage = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  margin: 16px;
  justify-content: center;
  border-radius: 4px;
  padding: 11px;
`;
